import classNames from 'classnames';

import styles from './radio-button.module.scss';

export const RadioButton = ({
  name,
  value,
  isChecked,
  label,
  disabled = false,
  onChange,
}: {
  name: string;
  value?: string;
  isChecked?: boolean;
  label: string | React.ReactNode;
  disabled?: boolean;
  onChange?: (value?: string) => void;
}) => {
  return (
    <label className={classNames(styles.radioButton, { [styles.disabled]: disabled })}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={isChecked === true}
        disabled={disabled}
        onChange={() => onChange?.(value)}
      />{' '}
      {label}
    </label>
  );
};
